import { forwardRef, useCallback } from 'react';

import { RelativeRoutingType, To, useNavigate, useNavLinkState } from '@spazious/dollhouse-router';
import { styled } from '@spazious/dollhouse-theme';

import { ToggleButton, ToggleButtonElement, ToggleButtonProps } from '../ToggleButton/index.js';

export type NavButtonElement = ToggleButtonElement;
export interface NavButtonProps extends ToggleButtonProps {
  to: To;
  end?: boolean;
  relative?: RelativeRoutingType;
  state?: any;
  replace?: boolean;
}

export const NavButton = styled(
  forwardRef<NavButtonElement, NavButtonProps>((props, fowardedRef) => {
    const { actived, pending } = useNavLinkState(props);

    const { to, relative, state, replace, onClick, ...restProps } = props;

    const navigate = useNavigate();

    const handleClick = useCallback<PickProp<ToggleButtonProps, 'onClick'>>(
      (evt) => {
        onClick?.(evt);

        if (to && !evt.defaultPrevented) {
          navigate(to, { replace, relative, state });
        }
      },
      [navigate, onClick, relative, replace, state, to]
    );

    return (
      <ToggleButton
        ref={fowardedRef}
        {...restProps}
        actived={actived || restProps.actived}
        disabled={pending || restProps.disabled}
        onClick={handleClick}
      />
    );
  })
).withConfig({
  displayName: 'NavButton',
})``;

export default NavButton;
